import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { PayerBillingListComponent } from './payer-billing-list/payer-billing-list.component';
import { InvoiceItemListComponent } from './invoice-item-list/invoice-item-list.component';
import { PayerBillingListService } from 'src/app/core/service/grid-data/grid-data-payer-billing.service';
import { PayerBillingItemListService } from 'src/app/core/service/grid-data/grid-data-payer-billing-item.service';
import { GenerateInvoiceComponent } from './generate-invoice/generate-invoice.component';
import { ExcelModule } from '@progress/kendo-angular-grid';

@NgModule({
  declarations: [
    PayerBillingListComponent,
    GenerateInvoiceComponent,
    InvoiceItemListComponent
  ],
  imports: [
    SharedModule,
    ExcelModule
  ],
  exports: [
    PayerBillingListComponent,
    GenerateInvoiceComponent,
    InvoiceItemListComponent
  ],
  providers: [
    PayerBillingListService,
    PayerBillingItemListService
  ]
})
export class PayerBillingModule { }
